import React from 'react';
import './StoryItem.scss';
import { Link } from 'react-router-dom';
import ReactTimeAgo from 'react-time-ago';

const StoryItem = ({ story, idx, type }) => {
  const getTime = (unix) => {
    const time = unix * 1000;
    return <ReactTimeAgo date={time} locale="en-US" />;
  };

  const mainUrlSource = (url) => {
    const _url = url.split('/');
    return _url[2];
  };

  const baseUrlSource = (url) => {
    const _url = url.split('/');
    return `${_url[0]}${_url[1]}${_url[2]}`;
  };

  const renderLinkTitle = () => {
    if (
      type === 'topstories' ||
      type === 'newstories' ||
      type === 'showstories' ||
      type === 'jobstories'
    ) {
      return (
        <a
          href={story.url}
          target="_blank"
          rel="noopener noreferrer"
          className="story-title-main"
        >
          {story.title}
        </a>
      );
    } else {
      return (
        <Link to={`/item/${type}/${story.id}`} className="story-title-main">
          {story.title}
        </Link>
      );
    }
  };

  return (
    <div className="story-item-container">
      {idx !== -1 && <p className="story-number">{idx + 1}.</p>}
      <div className="story-container">
        <div className="story-link-container">
          <p className="story-title">
            {renderLinkTitle()}
            <span className="story-source">
              {story.url && (
                <a
                  href={baseUrlSource(story.url)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ({mainUrlSource(story.url)})
                </a>
              )}
            </span>
          </p>
        </div>
        <div className="story-info-container">
          <p className="story-points">{story.score} points</p>
          <p className="story-by">
            by <Link to="/">{story.by}</Link>
          </p>
          <p className="story-time">
            <Link to={`/item/${type}/${story.id}`}>{getTime(story.time)}</Link>
          </p>
          <p className="story-comments">
            <Link to={`/item/${type}/${story.id}`}>
              {story.kids ? story.kids.length : 0} comments
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default StoryItem;
